import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from 'types';

interface ITRequisitionState {
  itRequisition: RequestFormHeader;
}

const initialState: ITRequisitionState = {
  itRequisition: getDefaultRequestState(),
};

const itRequisitionSlice = createSlice({
  name: 'itRequisition',
  initialState,
  reducers: {
    setITRequisition: (
      state: ITRequisitionState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.itRequisition = getDefaultRequestState();
      } else {
        state.itRequisition = payload;
      }
    },
  },
});

const { actions } = itRequisitionSlice;

export const itRequisitionActions = {
  ...actions,
};

export default itRequisitionSlice;
